import IconButton from "@/components/Button/IconButton";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { cn } from "@/lib/cn";
import type { CellContext } from "@tanstack/table-core";
import type { PropsWithChildren } from "react";

type Props<R> = PropsWithChildren<{
  cellCtx: CellContext<R, unknown>;
  togglePosition?: "left" | "right";
}>;

/**
 * サブ行を表示するためのトグルボタンを表示するセル
 */
export function ToggleCell<R>(props: Props<R>) {
  const { cellCtx, togglePosition = "right", children } = props;

  const button = (
    <IconButton
      variant="ghost"
      onClick={cellCtx.row.getToggleExpandedHandler()}
      icon="ChevronDownIcon"
      className={cn(
        "transition-transform duration-200 hover:bg-inherit",
        cellCtx.row.getIsExpanded() ? "rotate-0" : "-rotate-90",
      )}
      aria-label="toggle"
    />
  );

  return (
    <HStack className="gap-2 items-center text-nowrap justify-between">
      {cellCtx.row.getCanExpand() && togglePosition === "left" ? button : null}
      {/* 子要素がただのテキストの場合は、テキストのみを表示する。ズボラに実装 */}
      {typeof children === "string" ? (
        <Text variant="buttonLabelSmall" className="text-neutral-muted-on-fill">
          {children}
        </Text>
      ) : (
        children
      )}
      {cellCtx.row.getCanExpand() && togglePosition === "right" ? button : null}
    </HStack>
  );
}
